import { render, staticRenderFns } from "./EmptyExaminationInfo.vue?vue&type=template&id=78ac86d6&"
import script from "./EmptyExaminationInfo.vue?vue&type=script&lang=js&"
export * from "./EmptyExaminationInfo.vue?vue&type=script&lang=js&"
import style0 from "./EmptyExaminationInfo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {
  VFlex,
  VLayout,
})
